import {FORM_FIELDS} from '@/constants/help/index';

export const OBJECTION_NODE_ID = 'NODE0000000473';

export const OBJECTION_DOMAIN_ID = 'NODE0000000001';

export const OBJECTION_FIELD_ORDER = [
  FORM_FIELDS.OS_INFO,
  FORM_FIELDS.EMAIL,
  FORM_FIELDS.TITLE,
  FORM_FIELDS.CONTENT,
  FORM_FIELDS.FILES,
  FORM_FIELDS.AGREEMENT,
];

// 이의신청 페이지 > content placeholder
export const OBJECTION_DEFAULT_TEMPLATE = `문의 내용을 상세하게 기재하여 주세요.
\n※ 개인정보 보호를 위해 신분증과 같은 개인정보 항목을 첨부하실 경우,\n   주민등록번호 뒷자리가 노출되지 않도록 첨부 해주시기 바랍니다.`;
